import { t } from 'i18next';
import { useNavigate } from 'react-router-dom';
import { Text } from '@mantine/core';
import { Column, ReportsTableItem } from 'utils/models';
import { formatDate, calculateDaysBetweenDates } from 'utils/dates';
import { GroupBadge } from 'components/GroupBadge';
import { getReportIndicator } from 'utils/helpers';
import { useAppContext } from 'context/hooks';
import { IndicatorLabel } from 'components/IndicatorLabel';
import { PatientDetailsTabs } from 'pages/Main/Patients/Patients.helpers';
import { DurationIcon } from '../../DurationIcon/DurationIcon';
import { DownloadReportActionIcon } from '../DownloadReportActionIcon';

export const ReportsListColumns = () => {
  const navigate = useNavigate();
  const { currentUser } = useAppContext();
  const renderGroupName = (groupId: string) => currentUser?.visibleGroups.find((group) => groupId === group.id)?.name;

  const columns: Column<ReportsTableItem>[] = [
    {
      header: t('reports_trigger'),
      width: 10,
      renderItem: (item) => <Text>{`${t(`reason_${item.trigger.toLowerCase()}`)}`}</Text>,
    },
    {
      header: t('reports_duration'),
      width: 10,
      renderItem: (item) => (
        <DurationIcon label={calculateDaysBetweenDates(item.content.startTimestamp, item.content.endTimestamp)} />
      ),
    },
    {
      header: t('reports_timestamp'),
      width: 13,
      renderItem: (item) => formatDate({ timestamp: item.creationTimestamp, formatWithTime: true }),
    },
    {
      header: t('reports_indicator'),
      width: 10,
      renderItem: (item) => <IndicatorLabel indicator={getReportIndicator(item.tags)} />,
    },
    {
      header: t('reports_status'),
      width: 10,
      renderItem: (item) => <Text>{`${t(`report_${item.status.toLocaleLowerCase()}`)}`}</Text>,
    },
    {
      header: t('reports_last_updated'),
      width: 13,
      renderItem: (item) => formatDate({ timestamp: item.updateTimestamp, formatWithTime: true }),
    },
    {
      header: t('reports_patient'),
      width: 11,
      renderItem: (item) => <b>{`${item.firstName ? item.firstName : ''} ${item.lastName ? item.lastName : ''}`}</b>,
      onClick: (item) => navigate(`/patients/${item.userId}/details/${PatientDetailsTabs.Overview}`),
    },
    {
      header: t('reports_group'),
      width: 16,
      renderItem: (item) => (
        <GroupBadge key={item?.groupId} label={renderGroupName(item?.groupId)} groupId={item.groupId} />
      ),
    },
    {
      header: t('table_actions'),
      width: 6,
      renderItem: (item) => <DownloadReportActionIcon reportId={item.id} />,
    },
  ];

  return columns;
};
